export enum ActionType {
  GET_CUSTOMERS = 'GET_CUSTOMERS',
  SET_CUSTOMERS = 'SET_CUSTOMERS',
}

import type { Customer } from 'types'

export type CustomersParams = {
  limit?: number
  offset?: number
  query?: string
}

export type Customers = {
  data: Customer[]
}
